import bp from 'shared/constants/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Overlay = styled.div(
  (props: any) => css`
    min-height: calc(100vh - 10em);
    background-color: ${props.theme.bg};

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5em 0;

    img {
      position: absolute;
      top: 1em;
      left: 2em;
      height: 40px;

      @media screen and (max-width: ${bp.medium}) {
        height: unset;
        max-width: 75px;
        max-height: 35px;
        left: 1.5em;
      }
    }

    & > div:nth-of-type(2) {
      position: fixed;
      bottom: -5px;
      left: 0;
      right: 0;
      z-index: -1;
    }

    @media screen and (max-width: ${bp.small}) {
      padding-left: 1em;
      padding-right: 1em;
    }
  `
)

export const Content = styled.div`
  max-width: 600px;
`

export const Img = styled.img``
